import CartEvents from "./cart/events";

CartEvents();
